import React from 'react';
import { Flex } from '@tpr/core';
import Styles from './hint.module.scss';
export var Hint = function (props) {
    var className = props.expanded ? Styles.root : Styles.collapsed;
    if (props.className) {
        className += ' ' + props.className;
    }
    return (React.createElement(Flex, { cfg: { pl: 3 }, className: className }, props.children));
};
//# sourceMappingURL=hint.js.map